/**
 * FIN-12179 — Score-Computation table cell-merge (rowSpan) helper.
 *
 * computeGroupRowSpan groups consecutive rows that share the same value (per
 * `accessor`) into a single merged cell: the first row of a run gets rowSpan =
 * run length, the rest get 0 (antd omits a rowSpan-0 cell, so the cell above
 * covers it). The "previous row" check uses the PAGE-local index so merges reset
 * at each page boundary; the run length is counted in the DISPLAY-ordered array.
 *
 * Only Typology Name is grouped this way. Variant Name must NOT be grouped: a
 * Configure's variant-clones reuse the same rule (triggerName), so grouping by
 * triggerName merged two genuinely-different variant rows — blanking the 2nd
 * variant's name and, when a name repeated across typologies, over-running the
 * span so later columns (Group By, Function…) shifted left under the wrong
 * headers. Each variant row renders its own name (default rowSpan 1).
 */
export const computeGroupRowSpan = (
  orderedData,
  pageIndex,
  trueIndex,
  accessor
) => {
  if (!Array.isArray(orderedData) || !orderedData.length) return 1;
  const current = orderedData[trueIndex];
  if (!current) return 1;
  const value = accessor(current);

  // Continuation of a run that started on a previous (same-page) row → merged away.
  if (
    pageIndex >= 1 &&
    orderedData[trueIndex - 1] &&
    accessor(orderedData[trueIndex - 1]) === value
  ) {
    return 0;
  }

  // First row of a run → span the count of consecutive same-value rows.
  let span = 0;
  for (
    let i = 0;
    trueIndex + i !== orderedData.length &&
    orderedData[trueIndex + i] &&
    accessor(orderedData[trueIndex + i]) === value;
    i += 1
  ) {
    span = i + 1;
  }
  return span || 1;
};
